import { render, staticRenderFns } from "./DeliveryForm.vue?vue&type=template&id=ccae63a0&"
import script from "./DeliveryForm.vue?vue&type=script&lang=js&"
export * from "./DeliveryForm.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryForm.vue?vue&type=style&index=0&id=ccae63a0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports